import styled from '@emotion/styled';

export const ThumbnailWrapper = styled.img<{ size: number }>`
  object-fit: cover;
  width: ${({ size }) => size}px;
  height: ${({ size }) => size}px;
  border-radius: 4px;
  border: 1px solid rgba(0, 0, 0, 0.1);
`;
